// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" id=\"flag-icon-css-id\" viewBox=\"0 0 640 480\"> <g fill-rule=\"evenodd\" stroke-width=\"1pt\"> <path fill=\"#e70011\" d=\"M0 0h640v249H0z\"/> <path fill=\"#fff\" d=\"M0 240h640v240H0z\"/> </g> </svg> ";
// Exports
module.exports = code;